import type { CSSProperties } from 'react';

/** The empty slots: #stack (stock), .blank_foundation x n, .blank_tableau x n. Legacy ids/classes kept. */
export function Slots({ foundations, columns, cells = 0 }: { foundations: number; columns: number; cells?: number }) {
  return (
    <>
      {cells ? (
        // FreeCell: no stock; the free cells stand where the stock and waste would be
        <div id="cell_section" className="board__section">
          {Array.from({ length: cells }, (_, i) => (
            <div key={i} className="blank blank_cell" data-pile={`cell-${i}`} style={{ '--col': i } as CSSProperties} />
          ))}
        </div>
      ) : (
        <div id="stack_section" className="board__section">
          <div id="stack" className="blank blank_stock" data-pile="stock" />
        </div>
      )}
      <div id="dock_section" className="board__section">
        {Array.from({ length: foundations }, (_, i) => (
          <div key={i} className={`blank blank_foundation${i === 0 ? ' blank_foundation_first' : ''}`} data-pile={`foundation-${i}`} style={{ '--col': i } as CSSProperties} />
        ))}
      </div>
      <div id="board_section" className="board__section">
        {Array.from({ length: columns }, (_, i) => (
          <div key={i} className={`blank blank_tableau${i === 0 ? ' blank_tableau_first' : ''}`} data-pile={`tableau-${i}`} style={{ '--col': i } as CSSProperties} />
        ))}
      </div>
    </>
  );
}
